import React, { useEffect } from 'react'
import CustomModal from 'components/CustomModal/CustomModal'
import { useHistory } from 'react-router-dom'
import OptionsContent from './OptionsContent'

export const ACTION_SHARE = 'SHARE'

const OptionsModal = ({ show, onClose, userProfile, site, action, onEditPDF }) => {
  const history = useHistory()

  useEffect(() => {
    if (show) {
      const pathname = action === ACTION_SHARE ? '/manage/share' : '/manage/update'
      history.push({ pathname })
    }
  }, [show, action, history])

  const onHide = () => {
    const pathname = '/manage'
    history.push({ pathname })
    onClose()
  }

  return (
    <CustomModal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="md"
      className="success_modal"
      enforceFocus={false}
    >
      {site && (
        <OptionsContent site={site} userProfile={userProfile} action={action} onClose={onClose} onEditPDF={onEditPDF} />
      )}
    </CustomModal>
  )
}

export default OptionsModal
